import React, { useState } from 'react';
import { privateSitePrefix } from '../../Util/Config'
import { useSelector, useDispatch } from 'react-redux'
import * as Menu from '../../State/Menu'
import * as Login from '../../State/Login'
import * as Profile from '../../State/Profile';
import { useHistory } from 'react-router-dom'
import styled, { css } from 'styled-components';
import * as ButtonUi from '../../Component/Ui/Button'
import * as IconUI from '../../Component/Ui/Icon';
import * as Icon from '../../components/icons';
import * as SearchBarUi from '../../Component/Ui/SearchBar';
import * as FormUi from '../../Component/Ui/Form';
import * as StepperUi from '../../Component/Ui/Stepper';
import * as BasicElementUi from '../../Component/Ui/BasicElement';
import * as SelectUi from '../../Component/Ui/Select';
import { Link } from 'react-router-dom';
import ClickOutside from '../../Util/ClickOutside'
import { replaceAccents } from '../../Util/Format'
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useAlert } from 'react-alert'

export const ModalButtons = styled.div`
  display: flex;

  button {
    flex-grow: 1;
  }
`

export const ModalLogoutButton = styled(props => <ButtonUi.BasicButton {...props} />)`
  margin-right: 1rem;
`

export const LogoElement = styled.div`
  display: flex;
  justify-content: flex-start;
  min-height: 3rem;

  @media only screen and (min-width: ${props => props.theme.device.mobile}) {
    justify-content: center;
    flex: 1;
  }
`

export const NavLinkItem = styled.span`
  display: flex;
  color: ${props =>
    props.$on
      ? props.theme.primary
      : props.theme.grey
  };
  & > span:first-child {
    border-color: ${props => props.$on && props.theme.primary};
  }
  text-decoration: none;
  font-weight: ${props => props.$on ? '700' : '600'};
  flex: 1;
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.darkBlue};
    i, & > span:first-child {
      color: ${props => props.theme.primary};
      border-color: ${props => props.theme.primary};
    }
  }

  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    margin-right: 1.5rem;
  }
  @media only screen and (max-width: ${props => props.theme.device.largeDesktop}) {
    span {
      flex: initial;
      display: ${props => props.$on ? 'flex' : 'none'};
    }
  }
`

export const NavLink = ({ children, on, ...props }) =>
  <div>
    <NavLinkItem $on={on} {...props}>
      {React.Children.map(children, (child) =>
        typeof child === 'string'
          ? <span>{child}</span>
          : <>{child}</>
      )}
    </NavLinkItem>
  </div>

export const NavContainer = styled.div`
  padding-right: 0;
  flex: 1;
  display: flex;
  align-items: center;
  background-color: white;
  right: 0rem;
  left: ${props => props.isPublicSite ? '0' : 'calc(4rem + 359px)'};
  min-height: 3.8rem;
  z-index: 50;
  border-bottom: 1px solid;
  border-color: ${props => props.theme.primary};
  position: static;
  nav {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 2rem;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 0.8rem;
    height: 100%;
    @media only screen and (min-width: ${props => props.theme.device.desktop}) {
      justify-content: flex-start;
    }
    @media only screen and (min-width: ${props => props.theme.device.extraLargeDesktop}) {
      font-size: 0.875rem;
    }
    > div {
      display: flex;
      white-space: nowrap;
      span {
        padding-left: .3rem;
        padding-right: .3rem;
        align-items: center;
        justify-content: center;
      }
      @media only screen and (min-width: ${props => props.theme.device.desktop}) {
        span {
          padding-left: 9px;
        }
      }
      @media only screen and (max-width: ${props => props.theme.device.desktop}) {
        height: 50%;
        flex: 2.3rem 0 0;
        &:not(:last-child) {
          border-right: 1px solid ${props => props.theme.grey2};
        }
      }
    }
    i {
      font-size: 1.125rem;
    }
    @media only screen and (max-width: ${props => props.theme.device.desktop}) {
      margin: 0 .5rem;
    }
  }
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    position: ${props => props.isPublicSite ? 'static' : 'fixed'};
  }
`

export const NavLinks = ({ current, setCurrent, navItems }) => (
  <NavContainer>
    <nav>
      {navItems
        .map(([Icon, label], idx) => {
          return <NavLink
            key={idx}
            onClick={() => setCurrent(idx + 1)}
            on={current === idx + 1}
          >
            {Icon}{label}
          </NavLink>
        })
      }
    </nav>
  </NavContainer>
)

export const StepperContainer = styled(props => <NavContainer {...props} />)`
  nav {
    > div {
      align-items: center;
    }
    i {
      font-size: .85rem;
    }
    span {
      padding: 0 !important;
    }
  }
  ${StepperUi.StepCircle} {
    margin-right: .6rem;
  }
  ${StepperUi.StepLabel} {
    font-weight: 600;
  }
`

const Hamburger = styled.div`
  margin-top: .3rem;
  margin-left: .8rem;
  margin-bottom: .2rem;
  & > ${ButtonUi.Button} {
    width: 2.5rem;
    border: 0;
    background: none;
    box-shadow: none;
    &:hover {
      box-shadow: none;
    }
    > i {
      color: ${props => props.expanded ? props.theme.patientGreen : props.theme.white};
    }
  }
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    margin-top: 1rem;
  }
`

export const HeaderContainer = styled.header`
  display: flex;
  min-height: 3rem;
  box-shadow: ${props => props.theme.boxShadow.thin};
  background: ${props => props.theme.white};
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  padding-right: 1rem;
  box-sizing: border-box;
  position: fixed;
  width: 100vw;
  z-index: 100;
  img {
    height: 1.6rem;
  }
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    padding-left: 4.375rem;
  }

  ${Hamburger} {
    display: none;
    margin: 0;
    padding: 0;
    height: 100%;
    background: ${props => props.theme.darkBlue};
    margin-right: .8rem;
    align-self: stretch;
    padding: 0 .6em;
    @media only screen and (max-width: ${props => props.theme.device.mobile}) {
      display: flex;
      align-items: center;
    }
  }
  ${IconUI.IconChatOn} {
    position: relative;
    &::before {
      right: 12px;
    }
  }

  ${LogoElement} {
    align-items: center;

    @media only screen and (max-width: ${props => props.theme.device.mobile}) {
      display: flex;
      align-self: stretch;
    }
  }

  @media only screen and (min-width: ${props => props.theme.device.mobile}) {
    justify-content: center;
  }

  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    position: relative;
  }
`

export const MenuButton = styled.div`
  @media only screen and (max-width: ${props => props.theme.mobile}) {
    display: none;
  }
`

export const HeaderButtons = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 1rem;
  margin: 0;
  top: ${props => props.open ? '0' : '-330px'};
  transition: .5s;
  left: 0;
  box-shadow: 0 0 15px 1px rgba(134,174,197,0.4);


  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    justify-content: flex-end;
    padding: 1rem 0;
    position: relative;
    transition: none;
    top: 0%;
    flex-direction: row;
    width: auto;
    background-color: transparent;
    padding: 0;
    box-shadow: none;
  }
`

export const SidebarButtons = styled.div`
  display: none;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  flex: 1;
  margin: .4rem 0;
  ${props => props.expanded &&
    css`
      display: flex;
    `}
  & > a {
    text-decoration: none;
    margin-bottom: 1rem;

    & > span {
      min-width: 3.15rem;
      min-height: 3.15rem;
    }
  }

  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    display: flex;
  }
`

const SideBarContainer = styled.nav.attrs({ role: "navigation", "aria-label": "Menu principal" })`
  position: fixed;
  flex-direction: column;
  background: ${props => props.theme.darkBlue};
  width: 4rem;
  height: 100vh;
  align-items: flex-start;
  transition: .15s;
  box-sizing: border-box;
  display: flex;
  z-index: 200;
  ${SidebarButtons} {
    flex: 1;
  }

  > a, span {
    display: flex;
    justify-content: center;
    margin-left: .6rem;
    margin-right: .6rem;
    transition: .15s;
    border-radius: 50px;
    span {
      display: none;
    }
  }
  span:first-child {
    &:hover {
      box-shadow:inset 0px 0px 0px 1px #FFF;
    }
  }
  ${props => props.expanded &&
    css`
      height: 100%;
      transition: .15s;
      width: 15.5rem;
      font-size: 1rem;
      span {
        justify-content: flex-start;
        overflow: hidden;
        transition: .15s;
        display: flex;
        width: 14rem;
        > span {
          font-size: 1rem;
          display: inline-block;
          padding-left: 2.5rem;
          font-weight: 600;
        }
        > i {
          padding-left: .32rem;
          &::before {
            width: 1rem;
            font-size: 1rem;
          }
        }
      }
    `}

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    transform: ${props => props.expanded || 'translate(-4rem)'};
  }

  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    min-width: 4.375rem;
    height: 100%;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`

export const Main = styled.div`
  min-height: 100vh;
  padding-left: 4.375rem;
  display: flex;
  flex-flow: column nowrap;
  background-color: ${props => props.theme.lightGrey};
  section {
    /* margin-bottom: 1rem;
    margin-top: 1rem; */
    a {
      color: ${props => props.theme.patientGreen};
      text-decoration: none;
    }
    ${FormUi.InputContainer} {
      //margin-top: 1.1rem;
      //margin-bottom: 1.4rem;
    }
    ${BasicElementUi.H3} {
      margin-top: 0;
    }
  }

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    padding-left: 0;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 1.4rem;

  ${FormUi.InputContainer} {
    label {
      margin-top: 0;
      margin-bottom: 0;
    }
    display: flex;
    flex-direction: column;
  }
  & > div:not(:last-child) {
    margin-right: 2rem;
  }
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
   > div {
      flex: 1;
    }
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 1rem;
`

export const ButtonGroup = styled.div`
  display: flex;
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    a:not(:last-child), button:not(:last-child) {
      margin-right: .8rem;
    }
  }
  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    flex-direction: column;
    a:not(:last-child), button:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  @media only screen and (min-width: ${props => props.theme.device.mobile}) {
    padding: 0;
  }
`

export const Username = styled.div`
  font-size: .75rem;
  white-space: nowrap;
  color: ${props => props.theme.grey};
  font-weight: 600;
  display: flex;
  align-self: space-between;
  flex: 1;
  justify-content: space-between;
  display: ${props => props.visible ? 'flex' : 'none'};
`

export const ButtonGroupProfile = styled(props => <ButtonGroup {...props} />)`
  background: white;
  min-height: 3rem;
  top: 0;
  position: absolute;
  right: 1rem;
  align-items: center;
  min-width: ${props => props.visible ? '12.3rem' : 'auto'};
  justify-content: flex-end;
  transition: 2s;
  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    a:not(:last-child), button:not(:last-child) {
      margin-bottom: 0;
    }
    flex-direction: row;
  }
  & > button:not(:last-child) {
    margin-right: 0;
  }
`

export const PanelContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 80;
  position: fixed;
  width: auto;
  flex-shrink: 0;
  box-shadow: ${props => props.theme.boxShadow.right};
  box-sizing: border-box;
  top: 0;
  background: ${props => props.theme.white};
  padding-top: 90px;
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    width: 22.4rem;
  }

  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    /* padding-left: 1rem; */
    position: relative;
    height: auto;
    padding-top: 4rem;
    padding-bottom: 1rem;
  }
`

export const PanelFooter = styled.div`
  border-top: 1px dotted ${props => props.theme.primary};
  display: flex;
  height: 3rem;
  align-items: center;
  justify-content: center;
  ${BasicElementUi.P}, a {
    color: ${props => props.theme.primary};
  }
`

export const Panel = styled.div`
  flex: 1;
  padding: ${props => props.noPadding ? '0' : '1.5rem 1.5rem 0 1.8rem'};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  h1 {
    font-size: 1.5rem;
    line-height: 1.9rem;
    color: ${props => props.theme.primary}
  }

  header {
    display: flex;
    @media only screen and (max-width: ${props => props.theme.device.desktop}) {
      padding-top: 1rem;
    }
  }

  section {
    margin: 0;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    flex-direction: row;
  }
`

export const RadioGroupContainer = styled(props => <ContentWrapper {...props} />)`
  margin-top: 1.2rem;
  /* margin-bottom: 1rem; */
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const PageContentWrapper = styled(props => <ContentWrapper {...props} />)`
  align-items: stretch;
  height: 100%;
  overflow-y: auto;

  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    flex-direction: row;
    align-items: stretch;
    overflow: hidden;
  }
`

export const Content = styled.div`
  flex: 1;
  background-color: ${props => props.theme.lightGrey};
  padding-top: calc(85px + 2rem);
  padding-right: 2rem;
  min-height: 100vh;
  box-sizing: border-box;
  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    min-height: auto;
  }

  ${props => props.hasPanel && css`
    padding-left: calc(2rem + 359px);
  `}

  ${props => props.noPadding && css`
    padding-top: 89px;
    padding-left: 359px;
    padding-right: 0;
  `}

  h2 {
    font-weight: 600;
    font-size: 1.125rem;
    color: ${props => props.theme.darkBlue};
    line-height: 1.6rem;
  }

  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    padding-right: 1rem;
    padding-left: 1rem;
    padding-top: .6rem;
  }
`

export const FlexBox = styled.div`
  display: flex;
  width: ${props => props.width || '100%'};
  flex-flow: ${props => props.flow || 'row nowrap'};
  justify-content: ${props => props.justify || 'flex-start'};
  align-items: ${props => props.alignItems || 'stretch'};
  align-content: ${props => props.alignContent || 'flex-start'};
`

export const FullSpaceContainer = styled(props => <FlexBox {...props} />)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`

const SidebarButton = styled(props => <ButtonUi.Button {...props} />).attrs({ as: 'span' })`
  box-sizing: border-box;
  padding: 0.4rem 0.6rem;
  background-color: ${props => props.active ? props.theme.white : 'transparent'};
  font-size: 1.15rem;
  box-shadow: none;
  height: 3.15rem;
  min-width: 3.15rem;
  display: flex;
  align-items: center;
  color: white;
  &:active {
      text-decoration: none;
    }
  &:hover {
    background-color: ${props => props.active ? props.theme.white : 'transparent'};
  }
  > i {
    color: ${props => props.active ? props.theme.patientGreen : props.theme.white};
  }
  i:first-child {
    padding-right: 0;
  }
  > span {

  text-decoration: none;

    color: ${props => props.active ? props.theme.patientGreen : props.theme.white};
  }
`

const HelpButton = styled.div`
  ${SidebarButton} {
    border: 1px solid white;
  }
  margin-bottom: 1.5rem;
  span:first-child {
    &:hover {
      box-shadow: 'none';
    }
  }
  ${IconUI.IconHelpNoBorder} {
    font-size: 1.5rem;
  }
  a {
    text-decoration: none;
  }
`

export const ActionButtonsContainer = styled.div`
  display: flex;
  ${ButtonUi.Button}, a {
    &:not(:last-child) {
      margin-right: .4rem;
    }
    padding-top: 0;
    padding-bottom: 0;
    & i:first-child {
      margin: 0;
      padding: 0;
    }
  }
`

export const ActionButtonsContainerFixed = styled(props => <ActionButtonsContainer {...props} />)`
  position: fixed;
  right: 1.2rem;
  top: 8.1rem;
  @media only screen and (max-width: ${props => props.theme.device.desktop}) {
    display: none;
  }
`

export const ActionButtonsContainerMobile = styled(props => <ActionButtonsContainer {...props} />)`
  position: static;
  float: right;
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    display: none;
  }
`

export const SectionContainer = styled.div`
  box-sizing: border-box;
  background: white;
  width: 100%;
  box-shadow: ${props => props.theme.boxShadow.thin};
  padding: 1.5rem;
  border-radius: 5px;
  margin-bottom: 2rem;
`

export const ColleagueCardsContainer = styled.div`
  /* ${SearchBarUi.SearchBarContainer} {
    margin-top: .5rem;
  } */
  display: flex;
  flex-direction: row;
  margin-right: .5rem;
  flex-wrap: wrap;
  margin-right: 0;
`

export const SmallCardsContainer = styled.div`
  ${SearchBarUi.SearchBarContainer} {
    margin-top: .5rem;
  }
  display: flex;
  flex-direction: row;
  margin-right: .5rem;
  flex-wrap: wrap;
  margin-right: 0;
  margin-top: 2rem;
`

export const PaddedContent = styled.div`
  padding: 0.6rem 1rem 0 1rem;
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

export const Section = styled.section`
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    padding-right: ${props =>
    props.padded
      ? '3rem'
      : props.paddedSmall
        ? '2.5rem'
        : '0'
  }
  }
`

export const Form = styled.form``

export const DoctorThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-bottom: 1px solid ${props => props.theme.greyLight};
  padding-top: 2rem;
  padding-bottom: 1.5rem;

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    justify-content: flex-start;
    padding-left: 1rem;
    margin-top: 1rem;
  }
`

export const TelexpertiseThumbnailContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1.5rem;

  h3 {
    margin-top: 0;
    margin-left: 1rem;
    font-size: 1.8rem;
    color: ${props => props.theme.darkBlue};
  }
`

export const TelexpertiseDescription = styled.p`
  color: ${props => props.theme.darkBlue};
  opacity: .6;
  line-height: 1.71;
  margin-top: 0;
`

export const TelexpertiseLogo = styled.div`
  font-size: 1.3rem;
  background: ${props => props.theme.primary};
  color: ${props => props.theme.white};
  border-radius: 10000px;
  min-width: 50px;
  height: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`


export const DoctorThumbnail = styled.img`
  display: block;
  width: 45px;
  height: 45px;
  border-radius: 100000px;
  box-shadow: ${props => props.theme.boxShadow.thin};
  object-fit: cover;
  margin-right: 1rem;
`

export const DoctorIdentity = styled.div`
  flex-basis: 60%;
  p:first-child {
    color: ${props => props.theme.patientGreen};
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: .4rem;
  }
  p {
    margin: 0;
  }
`

export const PanelFilterContainer = styled.div`
    padding: .6rem ${props => props.noPadding ? '0rem' : '2.7rem'};
`

export const PanelFilterSubtitle = styled.p`
  border-bottom: 1px solid ${props => props.theme.greyLight};
  padding-bottom: .6rem;
  margin-top: 0;
  color: ${props => props.theme.darkBlue};
  font-weight: bold;

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    display: none;
  }
`

export const PanelFilterMobileLiner = styled.div`
  display: flex;
  justify-content: ${props => props.flexEnd ? 'flex-end' : 'space-between'};
  align-items: center;

  @media only screen and (min-width: ${props => props.theme.device.mobile}) {
    button {
      display: none;
    }
  }
`

export const PanelFilterTitle = styled.h2`
  font-size: 1.8rem;
  padding: .6rem 0;
  margin: 0;
  margin-top: .7rem;
  font-weight: 500;

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    font-size: 1.2rem;
    margin: 0;
  }
`

export const PanelFilterRow = styled.section`
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 0;
  display: ${props => props.mobileOnly ? 'none' : 'flex'};
  label {
    align-self: center;
  }
  > i {
    display: block;
    padding: .6rem;
    border: 1px solid ${props => props.theme.greyLight};
    border-radius: 10000px;
    font-size: 1.2rem;
    color: ${props => props.theme.patientGreen};
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${props => props.theme.greyLight};
  }

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    ${props => props.mobileOnly && css`display: flex;`}
  }
`

export const PanelFilterBox = styled.div`
  display: ${props => props.mobileOnly ? 'none' : 'block'};

  @media only screen and (max-width: ${props => props.theme.device.mobile}) {
    display: ${props => props.open ? 'block' : 'none'};
    border: 0;
    padding-bottom: 0;
  }

  ${props => props.isTelexpertise && css`
    border-bottom: 1px solid ${props => props.theme.mediumGrey};
    padding-bottom: .7rem;
    ${PanelFilterRow} {
      border: 0;
      padding: .6rem 0;
    }
  `}
`

export const PanelFilterRowMobile = styled.div`
  align-items: stretch;
  justify-content: flex-start;
  padding: .6rem 0;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    display: none;
  }

  ${SearchBarUi.SearchBarContainer} {
    margin-bottom: 0;
  }

  > * {
    flex-basis: 100%;
  }

  &:last-of-type {
    align-items: center;
    justify-content: center;

    > * {
      flex-basis: auto;
    }
  }
`

export const PanelFilterCounter = styled.p`
  padding: 0;
  margin: 0;
  font-size: 2.4rem;
  font-weight: 0;
  padding: 0 1rem 0 1rem;
  min-width: 2.3rem;
  text-align: right;
`

export const PanelFilterLabel = styled.p`
  font-size: .825rem;
  padding: 0;
  margin: 0;
  flex-grow: 2;
  color: ${props => props.theme.darkBlue};
`

export const Choice = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.darkBlue};
  font-size: .875rem;
  margin-bottom: .7rem;
  margin-right: 1.1rem;
  label {
    margin-right: .4rem;
  }
  label > span {
    margin-left: .4rem;
    font-weight: normal;
  };
`

export const ModeChoice = styled(props => <FlexBox {...props} />)`
  flex-direction: column;
  align-items: flex-start;
  ${RadioGroupContainer} {
    flex: initial;
    margin-left: 1.1rem;
  }
  ${BasicElementUi.WhiteBox} {
    > div {
      min-width: 12rem;
      padding: 0 1rem;
    }
  }
  @media only screen and (min-width: ${props => props.theme.device.desktop}) {
    flex-direction: row;
    align-items: center;
  }
`

const UserPanel = styled.div``;

export const PageLayout = ({
  currentUser,
  children,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const alert = useAlert();
  const [expanded, setExpand] = useState(false);
  const [userPanelOpen, setUserPanelOpen] = useState(false);
  const [modalUserInfo, setModalUserInfo] = useState({firstname: {value: '', error: ''}, lastname: {value: '', error: ''}});
  const activeMenu = useSelector(Menu.selectActive)
  const [lastSubscriptionStepModalIsOpen, setLastSubscriptionStepModalIsOpen] = useState(currentUser?.lastname?.toLowerCase().includes('nom à changer') ? true : false);
  const [expertModal, setExpertModal] = useState({
    step: !lastSubscriptionStepModalIsOpen && typeof currentUser?.expert === 'undefined' ? 'proposeMyExpertise' : 'none',
    proposeMyexpertise: null,
    searchDisciplines: '',
    selectDisciplines: [],
  });
  const medicineWordDisciplines = useSelector(Profile.selectMedicineWordDisciplines)
  const [changeAppOpen, setChangeAppOpen] = useState(false);

  const updateUser = e => {
    e.preventDefault()

    if (modalUserInfo.lastname.value === '') {
      setModalUserInfo({...modalUserInfo, lastname: {...modalUserInfo.lastname, error: 'Ce champ est requis'}});
    }
    if (modalUserInfo.firstname.value === '') {
      setModalUserInfo({...modalUserInfo, firstname: {...modalUserInfo.firstname, error: 'Ce champ est requis'}});
    }

    if (modalUserInfo.lastname.value !== '' && modalUserInfo.firstname.value !== '') {
      dispatch(Profile.updateField({ name: 'lastname', value: modalUserInfo.lastname.value }));
      dispatch(Profile.updateField({ name: 'firstname', value: modalUserInfo.firstname.value }));
      dispatch(Profile.saveProfile());

      dispatch(Login.updateFirstnameLastname({firstname: modalUserInfo.firstname.value, lastname: modalUserInfo.lastname.value}));

      setLastSubscriptionStepModalIsOpen(false);
      setExpertModal({...expertModal, step:'createAccountSuccess'});
    }
  }

  return (
    <>
      <Modal
        open={lastSubscriptionStepModalIsOpen}
        onClose={() => dispatch(Login.logOut())}
        center
        classNames={{
          modal: 'rounded-lg',
        }}
        closeIcon={<Icon.Cross/>}
      >
        <h2 className='mt-[1rem] text-blue-dark text-[1.3rem]'>Finalisez votre inscription</h2>
        <p className='text-blue-dark text-[1rem]'>Afin de finaliser la création de votre compte SKEZI pour l’utilisation de SKEMEET, nous vous demandons de renseigner les informations suivantes :</p>
        <form onSubmit={e => updateUser(e)} noValidate>
          <FlexBox flow="column nowrap">
            <FormUi.FormGroup>
              <Row>
                <FormUi.TextInput
                  htmlFor="firstname"
                  label="Prénom"
                  value={modalUserInfo.firstname.value}
                  onChange={(e) => setModalUserInfo({...modalUserInfo, firstname: {value: e.target.value, error: ''}})}
                  error={modalUserInfo.firstname.error}
                  autoFocus
                  noSubmit
                />
                <FormUi.TextInput
                  htmlFor="lastname"
                  label="Nom"
                  value={modalUserInfo.lastname.value}
                  onChange={(e) => setModalUserInfo({...modalUserInfo, lastname: {value: e.target.value, error: ''}})}
                  error={modalUserInfo.lastname.error}
                  noSubmit
                />
              </Row>
            </FormUi.FormGroup>
          </FlexBox>
          <ModalButtons>
            <ModalLogoutButton
              isGreen
              onClick={() => dispatch(Login.logOut())}
            >
              Se déconnecter
            </ModalLogoutButton>
            <ButtonUi.BasicButton
              isFilled
              isGreen
              type="submit"
            >
              Terminer
            </ButtonUi.BasicButton>
          </ModalButtons>
        </form>
      </Modal>
      <Modal
        open={
          (
            !localStorage.getItem('cancelExpertModalDate') ||
            localStorage.getItem('cancelExpertModalDate').toString() !== new Date().setHours(0, 0, 0, 0).toString()
          ) &&
          expertModal.step !== 'none'
        }
        onClose={() => {
          localStorage.setItem('cancelExpertModalDate', new Date().setHours(0, 0, 0, 0))
          setExpertModal({...expertModal, step:'none'})
        }}
        center
        classNames={{
          modal: 'rounded-lg',
        }}
        closeIcon={<Icon.Cross/>}
      >
        <h2 className='mt-[1rem] text-blue-dark font-semibold text-[1.125em] leading-[1.7rem]'>
          {expertModal.step === 'createAccountSuccess' && 'Compte créé avec succès !'}
          {expertModal.step === 'proposeMyExpertise' && 'Proposer mon expertise ?'}
          {expertModal.step === 'selectYourSpeciality' && 'Veuillez nous indiquez votre discipline'}
        </h2>
        {(expertModal.step === 'createAccountSuccess' || expertModal.step === 'proposeMyExpertise') &&
          <>
            <p className='text-blue-dark text-[0.875rem] leading-[1.3rem]'>Acceptez-vous de proposer votre expertise afin d’aider d’autres médecins à diagnostiquer un patient ?</p>
            <div className='
              flex items-center gap-[0.75rem]
              max-md:flex-col
            '>
              <Icon.Expert /><span className='text-black font-semibold text-[0.875rem] leading-[1.3rem]'>Ce badge Expert apparaîtra sur votre profil.</span>
            </div>
            <div className='
              mt-[1.5rem] flex justify-end gap-[1.25rem]
              max-md:justify-center
            '>
              <div
                className='
                  cursor-pointer flex items-center px-[1rem] py-[0.5rem] gap-[0.5rem] border border-solid border-red-secondary rounded-lg hover:bg-red-tertiary
                  max-md:w-[50%] max-md:justify-center
                '
                onClick={() => {
                  dispatch(Profile.fetchMedicineWordDisciplines())
                  setExpertModal({...expertModal, step:'selectYourSpeciality', proposeMyexpertise: false})
                }}
              >
                <Icon.Cross className='h-[0.75rem]' color='#C33025' />
                <span className='font-semibold text-[0.875rem] leading-[1.3rem]'>Je refuse</span>
              </div>
              <div
                className='
                  cursor-pointer flex items-center px-[1rem] py-[0.5rem] gap-[0.5rem] bg-green-tertiary rounded-lg hover:bg-green-quaternary
                  max-md:w-[50%] max-md:justify-center
                '
                onClick={() => {
                  dispatch(Profile.fetchMedicineWordDisciplines())
                  setExpertModal({...expertModal, step:'selectYourSpeciality', proposeMyexpertise: true})
                }}
              >
                <Icon.Check />
                <span className='text-white font-semibold text-[0.875rem] leading-[1.3rem]'>J'accepte</span>
              </div>
            </div>
          </>
        }
        {expertModal.step === 'selectYourSpeciality' &&
          <div className='relative'>
            <div className='font-medium text-[0.875rem] leading-[1.5rem] mb-[0.5rem]'>Quelle est votre discipline ?</div>
            <div>
              <input
                className='
                  w-[33.75rem] py-[0.625rem] pl-[2.75rem] border border-solid rounded-full bg-gray-quaternary
                  placeholder:italic placeholder:text-[0.875rem] placeholder:leading-[1.5rem]
                  hover:border-green-quaternary outline-green-quaternary
                '
                placeholder='Rechercher l’intitulé de votre discipline'
                value={expertModal.searchDisciplines}
                onChange={(e) => setExpertModal({...expertModal, searchDisciplines:e.target.value})}
              />
              <Icon.Loupe className='absolute top-[2.75rem] left-[1rem]' />
            </div>
            {expertModal.selectDisciplines.length > 0 &&
              <div className='flex my-[1rem] gap-[0.5rem]'>
                {expertModal.selectDisciplines.sort().map((selectDiscipline) => {
                  return <div className='flex items-center border border-solid border-[#86AEC5] rounded-full bg-[#F2F6F9] py-[0.5rem] px-[0.75rem] gap-[0.5rem] text-center'>
                    <span className='text-blue-dark text-[0.75rem] leading-[1.5rem]'>{selectDiscipline}</span>
                    <Icon.Cross
                      className='cursor-pointer w-[0.75rem]'
                      onClick={() => setExpertModal({
                        ...expertModal,
                        selectDisciplines: expertModal.selectDisciplines.filter(item => item !== selectDiscipline)
                      })}
                    />
                  </div>
                })}
              </div>
            }
            {expertModal.searchDisciplines &&
              <div className='overflow-y-auto rounded-lg mt-[1rem] shadow-[0_2px_8px_0px_rgba(46,88,119,0.10)] w-[33.75rem] max-h-[16.5rem] text-[0.875rem] leading-[1.5rem]'>
                {medicineWordDisciplines
                  .filter((medicineWordDiscipline) => replaceAccents(medicineWordDiscipline.name.toLowerCase()).includes(replaceAccents(expertModal.searchDisciplines.toLowerCase())))
                  .map((medicineWordDiscipline, key, arr) => {
                    const isSelected = expertModal.selectDisciplines.includes(medicineWordDiscipline.name)

                    return <div
                      key={key}
                      className={`
                        ${key === 0 && 'rounded-t-lg'}
                        ${key === (arr.length - 1) && 'rounded-b-lg'}
                        ${isSelected && 'bg-green-light-tertiary'}
                        cursor-pointer flex justify-between items-center px-[0.75rem] py-[1rem]
                        hover:bg-green-light-tertiary
                      `}
                      onClick={() => {
                        setExpertModal({
                          ...expertModal,
                          searchDisciplines: '',
                          selectDisciplines: expertModal.selectDisciplines.includes(medicineWordDiscipline.name) ? expertModal.selectDisciplines.filter(item => item !== medicineWordDiscipline.name) : [medicineWordDiscipline.name]
                        })
                      }}
                    >
                      <span>{medicineWordDiscipline.name}</span>
                      {isSelected && <Icon.Check className='self-center' color='#3BC3A8' />}
                    </div>
                  })
                }
              </div>
            }
            <div className='mt-[1.5rem] flex justify-end gap-[1.25rem]'>
              <div
                className='
                  cursor-pointer flex items-center px-[1rem] py-[0.5rem] gap-[0.5rem] border border-solid border-green-tertiary rounded-lg
                  max-md:w-[50%] max-md:justify-center
                  hover:bg-green-light-tertiary
                '
                onClick={() => setExpertModal({...expertModal, step:'proposeMyExpertise'})}
              >
                <Icon.Cross className='h-[0.75rem]' color='#3BC3A8' />
                <span className='font-semibold text-[0.875rem] leading-[1.3rem]'>Annuler</span>
              </div>
              <div
                className={`
                  ${expertModal.selectDisciplines.length > 0 ? 'cursor-pointer' : 'cursor-not-allowed'} flex items-center px-[1rem] py-[0.5rem] gap-[0.5rem] bg-green-tertiary rounded-lg hover:bg-green-quaternary
                  max-md:w-[50%] max-md:justify-center
                `}
                onClick={() => {
                  if (expertModal.selectDisciplines.length > 0) {
                    dispatch(Profile.updateAndSaveField({ name: 'expert', value: expertModal.proposeMyexpertise, scope: Profile.SCOPE.profile }))
                    dispatch(Profile.updateAndSaveField({ name: 'speciality', value: expertModal.selectDisciplines[0], scope: Profile.SCOPE.profile }))
                    dispatch(Login.updateCurrentUserField({ name: 'expert', value: expertModal.proposeMyexpertise }))

                    setExpertModal({
                      step:'none',
                      searchDisciplines: '',
                      selectDisciplines: []
                    })

                    alert.show('Vos préférences ont été sauvegardées. Vous pourrez les modifier ultérieurement sur votre profil.', { timeout: 5000 })
                  }
                }}
              >
                <Icon.Check />
                <span className='text-white font-semibold text-[0.875rem] leading-[1.3rem]'>Sauvegarder</span>
              </div>
            </div>
          </div>
        }
      </Modal>
      <Modal
        open={changeAppOpen}
        onClose={() => setChangeAppOpen(false)}
        center
        classNames={{
          modal: 'rounded-xl',
        }}
        closeIcon={<Icon.Cross/>}
      >
        <div className='flex flex-col items-center'>
          <div className='text-[1.25rem] font-semibold mt-[1rem]'>Explorez nos solutions</div>
          <div className='mt-[1.5rem] text-center text-gray-primary text-[1rem] leading-[1.4rem]'>Nous avons rassemblé toutes nos solutions en un seul endroit. Cliquez sur une des solutions pour en savoir plus et accéder à la solution qui vous convient.</div>
          <div className='flex justify-center mt-[1.5rem]'>
            <div
              className='cursor-pointer flex flex-col items-center w-[14rem] mr-[1.5rem] h-[9rem] bg-[#EAF7F5] border-solid border-2 border-[#3BC3A8] rounded-lg shadow-[0_0_20px_0_rgba(34,87,122,0.1),-10px_0_140px_0_rgba(46,88,119,0.1)]'
              onClick={() => setChangeAppOpen(false)}
            >
              <Icon.Skemeet className='mt-[2rem] mb-[0.5rem]' />
              <div className='w-[9rem] text-center text-gray-primary text-[0.75rem] leading-[1.5rem]'>Solution de téléexpertise et e-RCP.</div>
              <Icon.Check color='#3BC0A7' className='self-end mt-[0.3rem] mr-[1rem]' />
            </div>
            <a
              className='cursor-pointer flex flex-col items-center w-[14rem] h-[9rem] bg-white rounded-lg shadow-[0_0_20px_0_rgba(34,87,122,0.1),-10px_0_140px_0_rgba(46,88,119,0.1)]'
              href={`${process.env.REACT_APP_SKEZIA_FRONT_URL}/projects`}
              target="_blank"
              rel="noreferrer"
              onClick={() => setChangeAppOpen(false)}
            >
              <Icon.Skezia className='mt-[2rem] mb-[0.5rem] w-[5.8rem]' />
              <div className='w-[9.5rem] text-center text-gray-primary text-[0.75rem] leading-[1rem]'>Solution de collecte de données sensibles et de gestion de e-cohortes.</div>
              <Icon.OpenInTab className='self-end mr-[1rem]' />
            </a>
          </div>
        </div>
      </Modal>

      <SideBar expanded={expanded} onClickOutside={e => setExpand(false)}>
        <Hamburger expanded={expanded}>
          <ButtonUi.Button onClick={(e) => setExpand(!expanded)}>
            {expanded
              ? <IconUI.IconClose />
              : <IconUI.IconMenu />
            }
          </ButtonUi.Button>
        </Hamburger>
        <SidebarButtons expanded={expanded}>
          <Link to={`${privateSitePrefix}/patients`} title="Patients" onClick={e => setExpand(false)}>
            <SidebarButton active={Menu.PATIENTS === activeMenu}>
              <IconUI.IconPatientSup />
              <span>Patients</span>
            </SidebarButton>
          </Link>
          <Link to={`${privateSitePrefix}/medecins`} title="Médecins" onClick={e => setExpand(false)}>
            <SidebarButton active={Menu.MEDECINS === activeMenu}>
              <IconUI.IconDoctor />
              <span>Médecins</span>
            </SidebarButton>
          </Link>
          <Link to={`${privateSitePrefix}/expertises`} title="Expertise" onClick={e => setExpand(false)}>
            <SidebarButton active={Menu.EXPERTISE === activeMenu}>
              <IconUI.IconExpertise />
              <span>Expertise</span>
            </SidebarButton>
          </Link>
          <Link to={`${privateSitePrefix}/rcps`} title="RCPs" onClick={e => setExpand(false)}>
            <SidebarButton active={Menu.STAFFS === activeMenu}>
              <IconUI.IconMessage />
              <span>RCPs</span>
            </SidebarButton>
          </Link>
          <Link to={`${privateSitePrefix}/cohortes`} title="Cohortes" onClick={e => setExpand(false)}>
            <SidebarButton active={Menu.COHORTES === activeMenu}>
              <IconUI.IconCohorte />
              <span>Cohortes</span>
            </SidebarButton>
          </Link>
        </SidebarButtons>
        <HelpButton>
          <Link to={`${privateSitePrefix}/aide`} title="Aide" onClick={e => setExpand(false)}>
            <SidebarButton active={Menu.HELP === activeMenu}>
              <IconUI.IconHelpNoBorder />
              <span>Aide</span>
            </SidebarButton>
          </Link>
        </HelpButton>
      </SideBar>

      <header className='flex justify-between fixed min-h-[5.375rem] items-center m-0 p-0 pl-[4.3rem] pr-4 box-border bg-white w-screen z-[100] shadow-[0_2px_5px_1px_rgba(134,174,197,0.4)]'>
        <div className='min-sm:hidden cursor-pointer flex items-center justify-center absolute left-0 bg-blue-dark h-[5.375rem] w-[4rem]' onClick={(e) => setExpand(!expanded)}><Icon.Menu className='h-[1.5rem] w-[1.5rem]' /></div>
        <div className='flex w-1/2'>
          <Icon.Skemeet className='ml-10' />
        </div>
        <div className='flex justify-end w-1/2'>
          <Icon.NinePointsSquare onClick={() => setChangeAppOpen(true)} className='cursor-pointer mx-10' />
          <span className='self-center h-8 w-[0.05rem] bg-gray-tertiary' />
          <Icon.Account onClick={() => setUserPanelOpen(!userPanelOpen)} className='cursor-pointer self-center mx-10' />
        </div>
        {userPanelOpen &&
          <ClickOutside
            Component={UserPanel}
            onClickOutside={() => setUserPanelOpen(false)}
          >
            <UserPanel>
              <div className='absolute top-[6rem] right-[2rem] flex flex-col shadow-lg bg-white rounded-lg w-[18.875rem] text-gray-primary'>
                <div className='cursor-pointer flex items-center pl-4 py-6 rounded-t-lg hover:bg-gray-tertiary' onClick={() => history.push(`${privateSitePrefix}/profil`)}><Icon.Account className='h-[1.5rem] w-[1.5rem] mr-[1rem]' color='#5F6368' />Mon compte</div>
                <div className='self-center h-[0.05rem] w-[17rem] bg-gray-tertiary' />
                <div className='cursor-pointer flex items-center pl-4 py-6 hover:bg-gray-tertiary' onClick={() => history.push(`${privateSitePrefix}/messages`)}><Icon.Message className='h-[1.5rem] w-[1.5rem] mr-[1rem]' color='#5F6368' />Mes messages</div>
                <div className='self-center h-[0.05rem] w-[17rem] bg-gray-tertiary' />
                {currentUser && 'ROLE_SUPER_ADMIN' === currentUser.role &&
                  <>
                    <a target="_blank" rel="noreferrer" href={`${process.env.REACT_APP_API_URL}/admin/show`}><div className='cursor-pointer flex items-center pl-4 py-6 hover:bg-gray-tertiary'><Icon.OpenInTab className='h-[1.1rem] w-[1.1rem] ml-[0.18rem] mr-[1rem]' color='#5F6368' />Backoffice</div></a>
                    <div className='self-center h-[0.05rem] w-[17rem] bg-gray-tertiary' />
                    <a target="_blank" rel="noreferrer" href={`${process.env.REACT_APP_API_SYMFONY6_URL}/backOfficeAdmin`}><div className='cursor-pointer flex items-center pl-4 py-6 hover:bg-gray-tertiary'><Icon.OpenInTab className='h-[1.1rem] w-[1.1rem] ml-[0.18rem] mr-[1rem]' color='#5F6368' />Backoffice V2</div></a>
                    <div className='self-center h-[0.05rem] w-[17rem] bg-gray-tertiary' />
                  </>
                }
                <div className='cursor-pointer flex items-center pl-4 py-6 hover:bg-gray-tertiary' onClick={() => history.push(`${privateSitePrefix}/profil/informations-legales`)}><Icon.Info className='h-[1.5rem] w-[1.5rem] mr-[1rem]' color='#5F6368' />Documents légaux</div>
                <div className='self-center h-[0.05rem] w-[17rem] bg-gray-tertiary' />
                <div className='cursor-pointer flex items-center pl-4 py-6 rounded-b-lg hover:bg-gray-tertiary' onClick={() => dispatch(Login.logOut())}><Icon.Logout className='h-[1.5rem] w-[1.5rem] mr-[1rem]' color='#5F6368' />Déconnexion</div>
              </div>
            </UserPanel>
          </ClickOutside>
        }
      </header>
      <Main>
        {children}
      </Main>
    </>
  )
}

const SideBar = ({
  onClickOutside = () => null,
  children,
  ...props
}) =>
  <ClickOutside Component={SideBarContainer} onClickOutside={onClickOutside} {...props}>
    {children}
  </ClickOutside>

export const CustomFieldContainer = styled.div`
  margin-top: 2rem;
  background: white;
  color: ${props => props.theme.darkBlue};
  box-shadow: ${props => props.theme.boxShadow.thin};
  padding: 1.4rem;
  border-radius: 5px;
`

export const CustomFieldElementContainer = styled.div``

export const CustomFieldElement = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: .7rem;
  border: 2px solid ${props => props.theme.lightGrey2};
  border-radius: 5px;
  padding: .615rem 1.1rem;
  background: white;
  font-size: 1.125rem;
  color: ${props => props.theme.darkBlue};
  ${FormUi.RadioCheck} {
    position: static;
  }
  i {
    color: ${props => props.theme.grey};
    margin-left: .8rem;
    &:hover:not(:last-child) {
      color: ${props => props.theme.patientGreen};
      cursor: pointer;
    }
  }
  span {
    font-size: 1;
    flex: 1;
    margin-left: 1rem;
  }
`

export const Empty = styled.div`
  flex: 1;
  visibility: hidden;
`

export const ContentPanel = styled.div``

export const Separator = styled.div`
  height: 1rem;
`

export const AttachmentsBox = styled.div`
  display: ${props => props.open ? 'block' : 'none'};
`

export const FocusDiv = styled.div`
  outline: none;
`

export const ViewTitleContainer = styled.div`
    margin-bottom: .5rem;
    p {
      margin-top: .3rem !important;
    }
    &:hover {
      cursor: text;
      background-color: ${props => props.theme.LightGrey4};
    }
`

export const ViewContentContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 700;
  color: ${props => props.theme.darkBlue};
  line-height: ${props => props.isText ? '1.5rem' : 'auto'};
  padding-bottom: ${props => props.isText ? '0' : '.3rem'};
  font-weight: ${props => props.bold ? '600' : 'normal'};
  font-style: ${props => props.italic ? 'italic' : 'normal'};
  text-transform: ${props => props.uppercase ? 'uppercase' : 'default'};
  text-align: ${props => props.center ? 'center' : 'left'};
  white-space: pre-wrap;
  min-height: 2.5rem;

  &:hover {
    cursor: ${props =>
    props.isText
      ? 'text'
      : props.canEdit
        ? `url("data:image/svg+xml;base64,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") 6 6, pointer;`
        : 'default'
  };
    background-color: ${props => props.canEdit ? props.theme.lightGrey4 : 'transparent'};
    ${props => props.canEdit &&
    css`
      box-shadow: -7px 0 0 0 #E5EDF3, 7px 0 0 0 #E5EDF3;
    `}
  }
  ${ColleagueCardsContainer} {
  width: 100%;
  margin-top: 0;
}
`

export const PublicUriContainer = styled(props => <FlexBox {...props} />)`
  ${BasicElementUi.H3} {
    margin-bottom: 0;
  }
  ${BasicElementUi.P} {
    margin: 0;
    padding-top: .3rem
  }
  > div {
    width: auto;
    ${FormUi.InputContainer} {
      margin-top: 0 !important;
    }
    input {
      margin-top: 0;
    }
  }
  ${FlexBox} {
    align-items: center;
  }
`

export const BlockContainer = styled.div`
  margin-bottom: 1.4rem;
  a {
    color: ${props => props.theme.patientGreen};
    text-decoration: none;
  }
`

export const TeleExpertiseBanner = styled.div`
  width: 100%;
  background: white;
  height: 4rem;
`

export const InputBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 1rem;
  &:not(:last-child) {
    margin-right: 1rem;
  }
  ${SelectUi.SelectContainer} {
    width: auto;
  }
  `

export const UpgradeMessage = ({ isTeleExpertiseLocked }) =>
  <PanelFooter>
    <BasicElementUi.ContentBlock>
      {isTeleExpertiseLocked
        ? <>Cette téléexpertise est limitée. <Link to={`${privateSitePrefix}/profil?tab=5`}>Upgradez-la.</Link></>
        : <>Cette téléexpertise PRO est illimitée.</>
      }
    </BasicElementUi.ContentBlock>
  </PanelFooter>
